
export class AdjuestUtils {
  /**
   * 去除删除调配的费用
   */
  static removeDelAdjuestCharges(charges) {
    const adjuestChages = []
    this.removeDelAdjuestCharges2(charges, adjuestChages)
    return adjuestChages
  }

  /**
   * @private
   */
  static removeDelAdjuestCharges2(charges, adjuestChages) {
    const len = charges.length
    for (let i = len - 1; i >= 0; i--) {
      const charge = charges[i]
      if (charge.adjustment) {
        const adjuest = this.getDelAdjuestCharge(charges, charge)
        if (adjuest) {
          adjuestChages.push(adjuest)
          charges.splice(i, 1)
          charges.splice(charges.indexOf(adjuest), 1)
          this.removeDelAdjuestCharges2(charges, adjuestChages)
          break
        }
      }
    }
  }

  /**
   * 根据调整费用获取被删除调整的原始费用
   */
  static getDelAdjuestCharge(charges, adjust) {
    let c = null
    for (const charge of charges) {
      if (charge.adjustment === false &&
        charge.jobUuid === adjust.jobUuid &&
        charge.accountId === adjust.accountId &&
        charge.chargeItemId === adjust.chargeItemId &&
        charge.receivable === adjust.receivable &&
        charge.currency === adjust.currency &&
        charge.rate === adjust.rate &&
        charge.amount === adjust.amount * -1 &&
        charge.quantity === adjust.quantity) {
        c = charge
      }
    }
    return c
  }
}
